const countMatches = (post, searchTerm, postsByParent) => {
    if (!searchTerm) {
        return 1;
    }
    const content = post.content || '';
    const matches = content.match(new RegExp(searchTerm, 'gi'));
    const childMatches = postsByParent[post.key]?.reduce((acc, childPost) => (acc + countMatches(childPost, searchTerm, postsByParent)), 0) || 0;
    const totalMatches = childMatches + (matches?.length || 0);
    return totalMatches;
};
export default countMatches;
//# sourceMappingURL=countMatches.js.map